export const APPEARANCES = {
  accent: 'accent',
  cta: 'cta',
  white: 'white',
  outline: 'outline',
  accentSecondary: 'accent-secondary',
  ctaSecondary: 'cta-secondary',
};

export const SIZES = {
  large: 'large',
  medium: 'medium',
  small: 'small',
};
